import React, { Component } from "react";

import Section from "./section";
import NavbarPage from "../../components/Navbar/Navbar";
import Contact from "../../components/Contact/Contact";
import Footer from "../../components/Footer/footer";
import CristaliaInformation from "../../components/CristaliaInformation/CristaliaInformation";

import scrollTo from "../../util/scrollTo";

export default class Cristalia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navClass: ""
    };
  }

  componentDidMount() {
    scrollTo();
  }

  render() {
    return (
      <React.Fragment>
        <NavbarPage
          navClass={this.state.navClass}
        />

        <Section />

        <CristaliaInformation />

        <Contact />

        <Footer />
      </React.Fragment>
    );
  }
}
